import React, { useState, useEffect } from 'react';
import rightArrow from '../../../Assets/Announcement/Assets-Desktop/arrow_right.svg';
import '../../../css/Weather/WeatherInformation.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { WeatherTerminalAlphaSorting } from '../../../Services/utils/AlphaSorting';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { ALL_WEATHER_ENDPOINT } from '../../../Services/config/apiEndPoints';


const WeatherInformation = props => {
    const [portData, setPortData] = useState([]);
    useEffect(() => {

        ApiCall(
            'GET',
            utilityBaseURL + ALL_WEATHER_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',

            },
        ).then((data) => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    data = WeatherTerminalAlphaSorting(data);
                    setPortData(data);
                }
            } else {
                 console.log('Something went wrong!');
            }
        });
    }, [])

    const handleWeather = (event) => {
        portData?.find((name) => {
            if (name?.terminal?.terminalName === portData[event]?.terminal?.terminalName) {
                window.open(name.weatherURL);
            }
        })
    }

    return (
        <div>
            <MetaDecorator title={TitleDescription.weatherPageTitle} description={TitleDescription.weatherPageDescription} />
            <Header  tilesFetched = {()=>{}}/>
            <div className='weathernavbar'>
                <small id="weathername">Weather Information </small>
            </div><hr className='navbarhr' />
            <div className="sectionPart">
                <div class="weatheroutsec">
                    {(portData?.map((name, index) => {
                        return (
                            <div onClick={() => handleWeather(index)}>
                                {index < (portData?.length / 2) && <div className='card1'>
                                    <div className='wiindex'>{index + 1}</div>
                                    <div className='witerminalNameCol1'>
                                        {name?.terminal?.terminalName?.split(':')[0]}
                                        <img src={rightArrow} width="10" height="20" class=" pt-1" alt="" loading="lazy" />
                                    </div>
                                </div>
                                }
                            </div>
                        );
                    }))}
                </div>
                <div class="weatheroutsec">
                    {(portData?.map((name, index) => {
                        return (
                            <div onClick={() => handleWeather(index)}>
                                {index >= (portData?.length / 2) && <div className='card2'>
                                    <div className='wiindex'>{index + 1}</div>
                                    <div className='witerminalName'>
                                        {name?.terminal?.terminalName?.split(':')[0]}
                                        <img src={rightArrow} width="10" height="20" class=" pt-1" alt="" loading="lazy" />
                                    </div>
                                </div>
                                }
                            </div>
                        );
                    }))}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default WeatherInformation;
